<template>
  <router-link :to="homePath">
    <div class="logo-container relative">
      <q-icon name="img:/src/assets/logo.svg" class="cursor-pointer" />
      <span class="text-12 text-secondary text-font-medium">Companies DB </span>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { ROUTES } from 'src/services/consts/routes.const'

const route = useRoute()

const homePath = computed(() => {
  return { name: ROUTES.COMPANY, query: { ...route.query } }
})
</script>

<style lang="scss">
.logo-container {
  i {
    height: 2.5rem;
    width: auto;
  }
  img {
    height: 2rem;
  }
  span {
    position: absolute;
    top: 1.625rem;
    left: 2.6rem;
  }
}
</style>
